import React from 'react';

export default ({ text }) => (
  <div className="heading">
    {text}
    <hr />
  </div>
);



// WEBPACK FOOTER //
// src/components/Heading.jsx